import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { removeAllFeatures } from "@mapsight/core/lib/feature-sources/actions";
import { createFilteredFeatureSourceSelector } from "@mapsight/core/lib/feature-sources/selectors";
import { FEATURE_SOURCES, MAP } from "../../config/constants/controllers";
import { translate } from "../../helpers/i18n";
import { createActivateAction, createDeactivateAction, } from "../../plugins/common/measure-distance";
import useControllableState from "../../hooks/useControllableState";
import MeasureDistanceInfo from "./measure-distance-overlay";
import ToolOverlay from "./tool-overlay";
const MeasureDistanceButton = ({ pluginName = "measureDistance", opened, onOpenedChange, }) => {
    const [isOpened = false, setIsOpened] = useControllableState({
        prop: opened,
        defaultProp: false,
        onChange: onOpenedChange,
    });
    const activate = useMemo(() => createActivateAction(MAP, pluginName), [pluginName]);
    const deactivate = useMemo(() => createDeactivateAction(MAP, pluginName), [pluginName]);
    const resetAction = useMemo(() => removeAllFeatures(FEATURE_SOURCES, `${pluginName}_featureSource`), [pluginName]);
    const featureSelector = useMemo(() => createSelector(createFilteredFeatureSourceSelector(FEATURE_SOURCES, `${pluginName}_featureSource`, MAP), (featureSourceState) => { var _a, _b; return (_b = (_a = featureSourceState === null || featureSourceState === void 0 ? void 0 : featureSourceState.data) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b[0]; }), [pluginName]);
    const dispatch = useDispatch();
    const feature = useSelector(featureSelector);
    const toggle = useCallback(() => {
        setIsOpened(!isOpened);
    }, [isOpened, setIsOpened]);
    const close = useCallback(() => {
        setIsOpened(false);
    }, [setIsOpened]);
    useEffect(() => {
        dispatch(isOpened ? activate : deactivate);
    }, [dispatch, deactivate, isOpened, activate]);
    const closeAndReset = useCallback(function () {
        dispatch(resetAction);
        close();
    }, [close, dispatch, resetAction]);
    return (_jsxs(Fragment, { children: [_jsx("button", { className: "ms3-map-overlay__button ms3-map-overlay__button--with-icon ms3-map-overlay__button--measure-distance", type: "button", onClick: toggle, children: _jsx("span", { className: "ms3-map-overlay__button__label", children: translate("ui.measure-distance.title") }) }), isOpened && (_jsx(ToolOverlay, { label: translate("ui.measure-distance.title"), onClose: closeAndReset, text: translate(feature
                    ? "ui.measure-distance.instructions-done"
                    : "ui.measure-distance.instructions"), children: feature && _jsx(MeasureDistanceInfo, { feature: feature }) }))] }));
};
export default MeasureDistanceButton;
